import { createFileRoute } from "@tanstack/react-router"
import BlogHomePage from "~/components/Blog/BlogHomePage"
import MarketingLayout from "~/layouts/MarketingLayout"

const Blogs = () => {
  return <BlogHomePage posts={{
    docs: [],
    totalDocs: 0,
    totalPages: 0,
    page: 0,
  }} categories={[]} currentPage={1} tag="all-tags" />
}

function BlogsWrapper() {
  return (
    <MarketingLayout>
      <Blogs />
    </MarketingLayout>
  )
}

export const Route = createFileRoute("/blog/admin")({
  component: BlogsWrapper,
})
